import { CompanyResponseDto } from '@planning/app/api'
import companyService from '@planning/services/companyService'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetCompaniesByIdsQuery implements IQueryMessage {
  static type = 'GetCompaniesByIdsQuery'
  type = GetCompaniesByIdsQuery.type

  constructor(public readonly ids: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getCompaniesByIdsQueryHandler: IQueryHandler<
  GetCompaniesByIdsQuery,
  IEvent<CompanyResponseDto[]>
> = async query => {
  const data = await companyService.getByIds(query.ids)

  return new Event(GetCompaniesByIdsQuery.type, data)
}
